import { useEffect, useState } from "react";

export const useWindowResizeDebounced = (delay = 300) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setTick((prev) => prev + 1);
      }, delay);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [delay]);

  return { rerenderKey: tick };
};
